import { http } from "./http"
import {
  NewSubRegion,
  SubRegionUpdatePayload,
  Region,
  Market,
} from "models/regions"

export const fetchRegions = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("regions", { searchParams }).json()
  return res as Array<Region>
}

export const fetchRegion = async (_key: string, id: string) => {
  const res = await http.get(`regions/${id}`).json()
  return res as Region
}

export const fetchMarket = async (_key: string, id?: string) => {
  const res = await http.get(`markets/${id}`).json()
  return res as Market
}

export const fetchMarkets = async (_key: string, subRegionId?: string) => {
  const { data } = await http
    .get(`markets?subRegionId=${subRegionId}`)
    .json<{ data: Array<Market> }>()
  return data
}

export const createSubRegion = async (pld: NewSubRegion) => {
  const res = await http.post("sub-regions", { json: pld }).json()
  return res as string
}

export const deleteSubRegion = async (id: string) =>
  await http.delete(`sub-regions/${id}`)

export const updateSubRegion = async (pld: SubRegionUpdatePayload) => {
  const { id, ...data } = pld
  const res = http.patch(`sub-regions/${pld.id}`, { json: data })
  return res as any
}

export const createMarket = async (pld: Market) => {
  const res = await http.post("markets", { json: pld }).json()
  return res as Partial<Market>[]
}

export const updateMarket = async (pld: any) => {
  const { id, ...data } = pld
  const res = http.patch(`markets/${id}`, { json: data })
  return res as any
}

export const deleteMarket = async (id: string) =>
  await http.delete(`markets/${id}`)

type UpdateRegionalFinancePld = {
  code: string
  id?: string
}

export const updateRegionalFinance = async (pld: UpdateRegionalFinancePld) => {
  const { id, code, ...data } = pld
  const res = http.put(`regions/${code}/regionalFinance/${id}`, {
    json: data,
  })
  return res as any
}

type DeleteRegionalFinancePld = {
  code: string
  id: string
}

export const removeRegionalFinance = async (pld: DeleteRegionalFinancePld) => {
  const { id, code } = pld
  await http.delete(`regions/${code}/regionalFinance/${id}`)
}
